import {
  Component,
  ElementRef,
  HostListener,
  Input,
  Output,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ChangeDetectorRef,
} from "@angular/core";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { NX_MODAL_DATA, NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EndorsementPopupComponent } from "../../../../popup/endorsement-popup/endorsement-popup.component";
import { PolicyMovementComponent } from '@shared/components/policy-movement/policy-movement.component';
// import { VehicleDetailsComponent } from '@shared/components/vehicle-details/vehicle-details.component';
import { ExtraCoverageEndorsementComponent } from '@shared/components/extra-cover/extra-coverage-endorsement/extra-coverage-endorsement.component'
import { NamedDriverComponent } from '@shared/components/named-driver/named-driver.component';
import { NoClaimDiscountComponent } from '@shared/components/no-claim-discount/no-claim-discount.component';
import { VehicleSumInsuredComponent } from '@shared/components/vehicle-sum-insured/vehicle-sum-insured.component';
// import { CustomerPartnerComponent } from '@shared/components/customer-partner/customer-partner.component';
import { VehicleDetailsComponent } from '@shared/components/vehicle-details/vehicle-details.component';
import { SharedModule } from '@shared/shared.module';
import { CoverageComponent } from '../../issuance/coverage/coverage.component';
import { CALCULATE_ENDT_PREMIUM, GET_NCD_ENQUIRY, SET_CURRENT_STEP, STORE_ENDORSEMENT, STORE_EXTRA_COVER_DETAILS, UPDATE_ENDORSEMENT_STEP2 } from '@store/sat-motor/sat-motor.action';
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { EndorsementVehicleDetailsComponent } from './endorsement-vehicle-details/endorsement-vehicle-details.component';
import { EndorsementCustomerPartnerComponent } from './endorsement-customer-partner/endorsement-customer-partner.component';
import { ScrollToError } from "@shared/classes/scroll-to-error";
import { UserResponse } from "@interfaces/user";
import { DriverNameComponent } from '@shared/components/driver-name/driver-name.component';
import { EHailingDriverComponent } from '@shared/components/e-hailing-driver/e-hailing-driver.component';
import moment from "moment";
import { WarningPopupComponent } from "../../../../shared/components/modal/warning-popup/warning-popup.component";


@Component({
  selector: 'app-endorsement-details',
  standalone: true,
  imports: [
    SharedModule,
    PolicyMovementComponent,
    EndorsementVehicleDetailsComponent,
    ExtraCoverageEndorsementComponent,
    NamedDriverComponent,
    NoClaimDiscountComponent,
    VehicleSumInsuredComponent,
    EndorsementCustomerPartnerComponent,
    // CustomerPartnerIndComponent,
    // CustomerPartnerComComponent,
    VehicleDetailsComponent,
  ],
  templateUrl: './endorsement-details.component.html',
  styleUrl: './endorsement-details.component.scss'
})
export class EndorsementDetailsComponent {

  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.endtStep1Issuance) endtIssuanceData$;

  @ViewChild(EndorsementVehicleDetailsComponent) endorsementVehicleDetailsChild: EndorsementVehicleDetailsComponent;
  @ViewChild(ExtraCoverageEndorsementComponent) extraCoverChild: ExtraCoverageEndorsementComponent;
  @ViewChild(NamedDriverComponent) namedDriverChild: NamedDriverComponent;
  @ViewChild(NoClaimDiscountComponent) noClaimDiscountChild: NoClaimDiscountComponent;
  @ViewChild(VehicleSumInsuredComponent) vehicleSumInsuredChild: VehicleSumInsuredComponent;
  @ViewChild(EndorsementCustomerPartnerComponent) endorsementCustomerPartnerChild: EndorsementCustomerPartnerComponent;

  @ViewChild('warningPopup') warningPopup!: TemplateRef<any>;
  warningPopupModal?: NxModalRef<WarningPopupComponent>;

  isEndorsement: boolean = true;
  nextButtonDisabled: boolean = false;
  endorsementType: any;
  endorsementTypeListOfValues: any;

  templateDialogRef?: NxModalRef<any>;
  // componentDialogRef?: NxModalRef<CoverageComponent>;

  popup_type: any;
  popup_message: any;

  cngeNoteData: any;
  customerData: any;
  agentData: any;
  coverageData: any;
  userInfo: any;
  nextButtonClicked: boolean = false;
  showFirstButton: boolean = true;

  COEngine = 'COE'; //Change of Engine
  Chassis = 'ENDT10'; //Change of Vehicle Chassis No
  VehNo = 'ENDT12'; //Change of Vehicle Registration No
  Loan = 'ENDT18'; //Hire Purchase/Employers' Loan/Leasing
  Model = 'ENDT34'; // Change of Make & Model
  RevisedSI = 'ENDT30'; // Revision of Sum Insured
  ExtCov = 'ENDT17'; // Extra Benefits
  NCDAllow = 'ENDT23'; //NCD Allowed
  NCDAmend = 'ENDT24'; //NCD Amendment
  NCDWithdraw = 'ENDT25'; //NCD Withdraw
  NamedDriver = 'ENDT22'; //Named Driver
  Reinstate = 'ENDT29'; //Reinstatement of Extra Coverage
  EInvoiceDetails = 'EC175'; // Amendment of E-Invoice Details

  endorsementTypeVehicleDetails(): boolean {
    // console.log("Checking endorsement type for vehicle details:", this.endorsementType);
    return this.endorsementType === this.COEngine ||
      this.endorsementType === this.Chassis ||
      this.endorsementType === this.Model ||
      this.endorsementType === this.VehNo ||
      this.endorsementType === this.Loan;
  }
  // endorsementTypeVehicleDetails: boolean = true;

  endorsementTypeVehicleSumInsured(): boolean {
    return this.endorsementType === this.RevisedSI;
  }
  // endorsementTypeVehicleSumInsured: boolean = true;

  endorsementTypeNoClaimDiscount(): boolean {
    return this.endorsementType === this.NCDAllow ||
      this.endorsementType === this.NCDAmend ||
      this.endorsementType === this.NCDWithdraw;
  }
  // endorsementTypeNoClaimDiscount: boolean = true;

  endorsementTypeExtraCoverage(): boolean {
    return this.endorsementType === this.Reinstate ||
      this.endorsementType === this.ExtCov;
  }
  // endorsementTypeExtraCoverage: boolean = true;

  endorsementTypeNamedDriver(): boolean {
    return this.endorsementType === this.NamedDriver;
  }
  // endorsementTypeNamedDriver: boolean = true;

  endorsementTypeEInvoiceCustomerPartner(): boolean {
    return this.endorsementType === this.EInvoiceDetails;
  }
  // endorsementTypeEInvoiceCustomerPartner: boolean = true;

  ///////////////////////////////////////////////////
  endorsement_details = true;

  constructor(
    private dialogService: NxDialogService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store
  ) { }

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    this.store.dispatch(new SET_CURRENT_STEP(2));
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.actionType$.subscribe((state) => {
      if (state) {
        this.isEndorsement = state.isEndorsement;
        // console.log("EndorsementDetailsComponent isEndorsement", this.isEndorsement);
      }
    });

    this.endtIssuanceData$.subscribe((state) => {
      if (state) {
        this.endorsementType = state.issuance.endorsementType;
        console.log("this.endorsementType", this.endorsementType);
      }
    });

    if (this.endorsementTypeExtraCoverage()) {
      this.endtCalculatePremium(null);
    }

  }

  // ngAfterViewInit() {}

  prepareEndorsementTypeListLov(): any {
    const lov = this.store.selectSnapshot<any>(state => state.SatMotorState?.lov);
    this.endorsementTypeListOfValues = lov?.endorsementList;
  }

  prepareEndorsementVehicelPolicyData(): any {
    const endtVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);
    console.log("endtVehiclePolicyData:", endtVehiclePolicyData);

    if (endtVehiclePolicyData) {
      this.customerData = endtVehiclePolicyData?.clientPartner;
      this.agentData = endtVehiclePolicyData?.mkagAgent;
      this.coverageData = endtVehiclePolicyData?.riskList;

      // console.log("customerData:", this.customerData);
      // console.log("agentData:", this.agentData);
      // console.log("coverageData:", this.coverageData);
    } else {
      console.error("endtVehiclePolicyData is undefined");
    }
  }

  // closeTemplateDialog() {
  //   this.templateDialogRef?.close();
  // }

  openWarningPopup(popupMessage: string): void {
    this.dialogService.open(this.warningPopup, {
      disableClose: true,
      width: '400px',
      data: { popup_message: popupMessage }
    });
  }

  goBack() {
    this.router.navigate(["endorsement/declaration-issuance-info"], {
      queryParamsHandling: 'preserve',
    });
  }

  async goNext(event: Event) {
    this.nextButtonClicked = true

    if (this.endorsementVehicleDetailsChild) {
      if (!this.endorsementVehicleDetailsChild.validateFields()) {
        this.endorsementVehicleDetailsChild.displayError(); //AGIC-49480
        this.updateNextButton();
        return;
      }
      const hasChanged = this.endorsementVehicleDetailsChild.validateChangedFields();
      if (!hasChanged) {
        this.openWarningPopup('Kindly make changes to proceed for endorsement.');
        this.updateNextButton();
        return;
      }
      this.endorsementVehicleDetailsChild.storeEndorsementDetailsData();
    }
    if (this.extraCoverChild) {
      const hasChanged = this.extraCoverChild.validateChangedFields();
      if (!hasChanged) {
        this.openWarningPopup('Kindly make changes to proceed for endorsement.');
        this.updateNextButton();
        return;
      }  
      
      const validateExtraCoverDetails = this.extraCoverChild.validateExtraCoverDetails();
      if(!validateExtraCoverDetails){
        this.updateNextButton();
        return;
      }

      const ehailingDriverDetails = this.extraCoverChild.validateEhailingDriver();
      if (!ehailingDriverDetails) {
        this.updateNextButton();
        return;
      }

      this.extraCoverChild.storeThailandTripDates();
    }
    if (this.namedDriverChild) {
      if (!this.namedDriverChild.isDriverOrEHailingDataUpdated()) {
        this.openWarningPopup('Kindly make changes to proceed for endorsement.');
        this.updateNextButton();
        return;
      } else {
        const ehailingNamedDriverDetails = this.namedDriverChild.validateEhailingDriver();
        if (!ehailingNamedDriverDetails) {
          this.updateNextButton();
          return;
        }
        this.namedDriverChild.storeEndorsementDetailsData();
        
      }
    }
    if (this.noClaimDiscountChild) {
      const hasChanged = this.noClaimDiscountChild.validateChangedFields();
      if (!hasChanged) {
        this.openWarningPopup('Kindly make changes to proceed for endorsement.');
        this.updateNextButton();
        return;
      }
      this.noClaimDiscountChild.storeEndorsementDetailsData();
    }
    if (this.vehicleSumInsuredChild) {
      const hasChanged = this.vehicleSumInsuredChild.validateChangedFields();
      if (!hasChanged) {
        this.openWarningPopup('Kindly make changes to proceed for endorsement.');
        this.updateNextButton();
        return;
      }
      this.vehicleSumInsuredChild.storeEndorsementDetailsData();
    }
    if (this.endorsementCustomerPartnerChild) {
      let step2Data = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
      let endtCPType = this.store.selectSnapshot<any>(SatMotorState.endtCpType);
      console.log("goNext step2Data:", step2Data);

      let validForm = this.endorsementCustomerPartnerChild.validateForm();

      if (!this.endorsementCustomerPartnerChild.eInvoiceCustomerPartnerForm.valid || !validForm) {
        this.endorsementCustomerPartnerChild.eInvoiceCustomerPartnerForm.markAllAsTouched();
        ScrollToError.scrollToError('.ng-invalid[formControlName]');
        this.updateNextButton();
        return;
      }

      if (endtCPType !== "FOUND") {
        if (!this.endorsementCustomerPartnerChild.hasChangedFields()) {
          this.openWarningPopup("Kindly update Customer Partner details to proceed for endorsement.");
          this.updateNextButton();
          return;
        }
      }

      await this.endorsementCustomerPartnerChild.storeEndorsementDetailsData();

      let updatedCustomerPartner = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step2.endorsementDetails.eInvoiceCustomerPartner);
      step2Data = {
        ...step2Data,
        clientPartner: updatedCustomerPartner
      }

      let payload = {
        isReset: false,
        cngeNote: step2Data //cngeNote
      }

      console.log("goNext payload:", payload);

      this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2(payload));
    }

    if (this.endorsementType === 'XP' || this.endorsementType === 'ENDT04' 
      || this.endorsementType === 'ENDT05') {
      this.endtCalculatePremium(null);
    
    } else if (this.endorsementType === 'COE' || this.endorsementType === 'ENDT22' 
      || this.endorsementType === 'ENDT23' || this.endorsementType === 'ENDT24' 
      || this.endorsementType === 'ENDT25' || this.endorsementType === 'ENDT30'
      || this.endorsementType === 'ENDT34') {
      // DO Nothing. Wait for Premium Calculation complete then redirect
    } else {
      this.router.navigate(['endorsement/summary'], {
        queryParamsHandling: 'preserve',
      });
    }

  }

  updateNextButton() { //AGIC-49463
    this.nextButtonClicked = false;
    this.showFirstButton = !this.showFirstButton;
  }

  parseAndFormatDate(dateString) {
    if (!dateString) {
      return dateString;
    }
  
    let parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().split('T')[0];
    } else {
      return this.parseDateWithMoment(dateString);
    }
  }

  parseDateWithMoment(dateString) {
    const parsedDate = moment(dateString, moment.ISO_8601, true);
    if (!parsedDate.isValid()) {
      return dateString;
    }
    return parsedDate.format('YYYY-MM-DD');
  }

  endtCalculatePremium(data) {

    let policy = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1.policyData);
    let coverNoteDto = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
    let step1Data = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.issuance?.issuance ?? null);
    let endtEffectiveDate, endtExpiryDate, expiryDate;

    if (step1Data) {
      endtEffectiveDate = this.parseAndFormatDate(step1Data.endtEffectiveDate);
      endtExpiryDate = this.parseAndFormatDate(step1Data.endtExpiryDate);
      expiryDate = this.parseAndFormatDate(step1Data.expiryDate || step1Data.policyExpiryDate);
    }

    //only for cr14 optional package

    coverNoteDto = {
      ...coverNoteDto,
      cnoteType: this.endorsementType,
      ...(step1Data && {
        endtEffectiveDate,
        endtExpiryDate,
        expiryDate
      }),
      riskList: [
        {
          ...coverNoteDto.riskList[0],
          coverList: [{
            ...coverNoteDto.riskList[0].coverList[0],
            coverDto: { 
              ...coverNoteDto.riskList[0]?.coverList[0].coverDto,
              extCovPackageSelected: coverNoteDto.riskList[0]?.coverList[0]?.subCovPackage 
            }
          }],
          vehicleCapacity: typeof coverNoteDto.riskList[0]?.vehicleCapacity === 'string' &&
            coverNoteDto.riskList[0].vehicleCapacity.includes(',')
            ? coverNoteDto.riskList[0].vehicleCapacity.replace(/,/g, '')
            : coverNoteDto.riskList[0]?.vehicleCapacity,
          makeModel: this.isOldMakeModel(coverNoteDto.riskList[0])
        }
      ]
    };

    if (!coverNoteDto.riskList[0]?.vehicleModel ||
      coverNoteDto.riskList[0]?.vehicleModel === '') {

      if (this.endorsementType !== 'ENDT34') {
        coverNoteDto.riskList[0].vehicleModel = policy?.cngeNoteDto?.riskList[0]?.vehicleModel || '';
      } else {
        coverNoteDto.riskList[0].vehicleModel = coverNoteDto.riskList[0].vehModelNvic || '';
      }
    }

    if (coverNoteDto.riskList[0].cngeRiskDrvrDtoList) {
      coverNoteDto.riskList[0].cngeRiskDrvrDtoList = this.checkDriverAge(coverNoteDto.riskList[0].cngeRiskDrvrDtoList);
    }

    let payload = {
      productType: coverNoteDto?.productCode,
      vehicleUse: coverNoteDto?.riskList[0].vehicleUse,
      vehicleNo: coverNoteDto?.riskList[0].vehicleNo,
      previousNcdVehicle: coverNoteDto?.riskList[0].vehicleNo,
      idType: coverNoteDto?.clientPartner.idType1,
      idNo1: coverNoteDto?.clientPartner.idValue1
    };

   // this.store.dispatch(new GET_NCD_ENQUIRY(payload)).subscribe((state) => {
    // let ncdInfo = state.SatMotorState.ncdEnquiryDetails;

      // if (ncdInfo?.ismRefNo && (this.endorsementType === 'ENDT23' || this.endorsementType === 'ENDT24' || this.endorsementType === 'ENDT25' || this.endorsementType === 'XP')) {
      //   coverNoteDto = {
      //     ...coverNoteDto,
      //     // effectiveDate: latestEffDate,
      //     // expiryDate: latestExpDate,
      //     riskList: [
      //       {
      //         ...coverNoteDto.riskList[0],
      //         ismRefNo: ncdInfo.ismRefNo,
      //         prevNcdExpDate: ncdInfo.currPctExpDate, 
      //         nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
      //         nextNcdPct: this.getNcdPercentage(coverNoteDto ,ncdInfo, true), 
      //         ncdEffDate: this.getNcdEffectiveDate(coverNoteDto ,ncdInfo),
      //         coverList: [{
      //           ...coverNoteDto.riskList[0].coverList[0],
      //           ncdPercentage: this.getNcdPercentage(coverNoteDto ,ncdInfo, false),
      //           ncdEffDate: this.getNcdEffectiveDate(coverNoteDto ,ncdInfo),
      //         }]
      //       }
      //     ]
      //   };
      // }

      this.store.dispatch(new CALCULATE_ENDT_PREMIUM({
        ...policy,
        operator: this.userInfo.userId,
        userId: this.userInfo.userId,
        cngeNoteDto: coverNoteDto
      }))
        .subscribe((stateLvl1) => {
          if (stateLvl1) {
            this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
              isReset: false,
              cngeNote: stateLvl1.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data.cngeNoteDto
            })).subscribe((stateLvl2) => {
              if (this.endorsementType === 'XP' || this.endorsementType === 'ENDT04'
                || this.endorsementType === 'ENDT05' || this.endorsementType === 'COE' || this.endorsementType === 'ENDT22') {
                this.router.navigate(['endorsement/summary'], {
                  queryParamsHandling: 'preserve',
                });
              }

              if (this.nextButtonClicked && (this.endorsementType === 'ENDT23'
                || this.endorsementType === 'ENDT24' || this.endorsementType === 'ENDT25'
                || this.endorsementType === 'ENDT30' || this.endorsementType === 'ENDT34')) {
                this.router.navigate(['endorsement/summary'], {
                  queryParamsHandling: 'preserve',
                });
              }

              let cnoteType = stateLvl2?.SatMotorState?.endorsement?.step2?.endorsementDetails?.coveragePremium?.data?.cngeNoteDto?.cnoteType;
              let latestCngeNotePremium = stateLvl1?.SatMotorState?.endorsement?.step2?.endorsementDetails?.coveragePremium?.data?.cngeNoteDto;
              if(latestCngeNotePremium && latestCngeNotePremium.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList){
                this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
                  isReset: false,
                  cngeNote: this.updateSubCovList(stateLvl1.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data.cngeNoteDto)
                }))
              }
                
              if (cnoteType === 'ENDT17' || cnoteType === 'ENDT29') {
                this.store.dispatch(new STORE_EXTRA_COVER_DETAILS(
                  stateLvl2.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data.cngeNoteDto
                ));
              }
            });
          }
        });
    //}); 
  }

  updateSubCovList(cngeNoteDto) {
    return {
      ...cngeNoteDto,
      riskList: [{
        ...cngeNoteDto.riskList[0],
        coverList: [{
          ...cngeNoteDto.riskList[0].coverList[0],
          subCoverList: this.updateSubCoverList(cngeNoteDto.riskList[0].coverList[0].subCoverList, cngeNoteDto.riskList[0].coverList[0].coverDto.subCovList) || [],
          coverDto: {
            ...cngeNoteDto.riskList[0].coverList[0].coverDto,
            subCovList: this.removeElementEndorsementPOIList(cngeNoteDto.riskList[0].coverList[0].coverDto.subCovList) || []
          }
        }]
      }]
    };
  }
  
  removeElementEndorsementPOIList(subCovList) {
    if(subCovList && subCovList.length > 0){
      return subCovList.map(subCover => {
        const { elementEndorsementPOIList, ...rest } = subCover;
        return rest;
      });
    }
    
    return subCovList
  }

  
  updateSubCoverList(subCoverList: any, subCovList: any) {
    if (subCoverList && subCoverList.length > 0) {
      return subCoverList.map(subCover => {

        let matchingObj = subCovList?.find(obj2 => obj2.subCoverCode === subCover.subCoverCode);
        if (matchingObj) {
          subCover = { ...subCover, annualPremium: matchingObj.annualPremium}
        }

       // if (subCover.subCoverCode === '57') {
        return { ...subCover, subCoverCodeDescription: subCover.subCoverDescp }
        //}

        //return subCover;
      });
    }
  }

  checkDriverAge(cngeRiskDrvrDtoList: any): any {
    if (!Array.isArray(cngeRiskDrvrDtoList)) {
      console.log("Invalid input: Expected an array.");
      return cngeRiskDrvrDtoList;
    }

    return cngeRiskDrvrDtoList.map(driver => {
      if (!driver || typeof driver !== "object") {
        console.log("Skipping invalid driver entry:", driver);
        return {};
      }

      return {
        ...driver,
        driverId: driver.driverId === "N/A" || driver.driverId === undefined ? "" : driver.driverId,
        driverAge: driver.driverAge === "N/A" || driver.driverAge === undefined ? "" : driver.driverAge
      };
    });
  }

  isOldMakeModel(risk: any) {
    if (risk && risk.vehModelNvic && risk.vehModelNvic.trim() !== '') { //new model
      return risk.makeModel;

    } else if (risk && risk.vehicleModelDescp && risk.vehicleModelDescp.trim() !== '') { //old model
      return risk.vehicleModelDescp;
    }

    return risk.makeModel;
  }

  isNextButtonDisabled() {
    // if (this.noClaimDiscountChild) {
    //   return !this.noClaimDiscountChild.isValidForm();
    // } else {
    //   return false;
    // }
    return false;
  }

  getNcdPercentage(cngeNote: any, ncdEnquiryDetails: { currPctExpDate: Date, nextNcdPctEffDate: Date, nextNcdPct: number, currNcdPct: number, errMsg: string }, showPopup): any {
    const riskList = cngeNote?.riskList?.[0];
    let ncdPercentage = 0;

    if (this.endorsementType === 'ENDT23' || this.endorsementType === 'ENDT24' || this.endorsementType === 'ENDT25') {  
      return riskList?.coverList[0]?.ncdPercentage;
    } //Use User selected NCD Percentage for these three Endt Types //AGIC-50786


    if (this.endorsementType === this.RevisedSI) {
      const policyMovemementData = this.store.selectSnapshot<any>(state => state.SatMotorState?.data?.step2?.endorsementDetails?.policyMovemementData);
      if (policyMovemementData && policyMovemementData.length) {
        if (policyMovemementData[0].endorsementCode === "23") 
          return riskList?.coverList[0]?.ncdPercentage;
      }
    }

    if (riskList?.coverList?.[0] && ncdEnquiryDetails.currPctExpDate && ncdEnquiryDetails.nextNcdPctEffDate && this.endorsementType === 'XP') {
      // Convert date strings to Date objects if necessary
      const currPctExpDate = new Date(ncdEnquiryDetails.currPctExpDate);
      const nextNcdPctEffDate = new Date(ncdEnquiryDetails.nextNcdPctEffDate);
      const todaysDate = new Date(cngeNote.effectiveDate);

      // Determine the correct NCD percentage based on date comparison
      if (currPctExpDate < todaysDate || todaysDate >= nextNcdPctEffDate) {
        ncdPercentage = ncdEnquiryDetails.nextNcdPct;
      } else { 
        ncdPercentage = ncdEnquiryDetails.currNcdPct;
      }

      if(ncdEnquiryDetails.errMsg && this.endorsementType === 'XP' && showPopup){ 
        this.warningPopupTwo("warningPopupTwo", ncdEnquiryDetails.errMsg);
      }

      return ncdPercentage;
    }else{
      if(ncdEnquiryDetails){
        ncdPercentage = ncdEnquiryDetails.currNcdPct ? ncdEnquiryDetails.currNcdPct : 0;

        if (ncdEnquiryDetails.errMsg && this.endorsementType === 'XP', showPopup) {
          this.warningPopupTwo("warningPopupTwo", ncdEnquiryDetails.errMsg);
        }
      }
      
      return ncdPercentage? ncdPercentage : 0;
    }
  }

  getNcdEffectiveDate(cngeNote: any, ncdEnquiryDetails: { currPctExpDate: Date, nextNcdPctEffDate: Date, nextNcdPct: number, currNcdPct: number, errMsg: string }): any {
    const riskList = cngeNote?.riskList?.[0];

    if (this.endorsementType === 'ENDT23' || this.endorsementType === 'ENDT24' || this.endorsementType === 'ENDT25') {  
      return riskList?.coverList[0]?.ncdEffectiveDate;
    }else{
      return ncdEnquiryDetails.nextNcdPctEffDate || "";
    }
  }

  warningPopupTwo(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
    this.warningPopupModal.afterClosed().subscribe((result) => {
    });
  }

}
